import { motion } from "framer-motion";
import Apply from "@/components/Apply";
import SEO from "@/components/SEO";

interface TeamMember {
  name: string;
  title: string;
  photo: string;
}

const Team = () => {
  const teamMembers: TeamMember[] = [
    {
      name: "Monsieur Ibrahima TALL",
      title: "Coordonnateur du Projet Mobilier National",
      photo: "/Ibr-tall.jpg",
    },
    {
      name: "Ramatoulaye BA",
      title: "Coordonnateur adjoint du Projet Mobilier National",
      photo: "/ad-sow.jpg",
    },
    {
      name: "Bassirou Hamedine SY",
      title: "Responsable Administratif et Financier",
      photo: "/sy-raf.jpg",
    },
    {
      name: "Papa Elhadj  Becaye GAYE ",
      title: "Comptable",
      photo: "/papa-gaye.jpg",
    },
    {
      name: "Khadidiatou DAFFE",
      title: "Comptable des matières",
      photo: "/daffe.webp",
    },
    {
      name: "Rose Aimée Diagne FAYE",
      title: "Ressources humaines",
      photo: "/rose.webp",
    },
    {
      name: "Madame KEITA",
      title: "Pôle programmes et projets",
      photo: "/keita.jpg",
    },
    {
      name: "Ndeye Khane FAYE",
      title: "Chargés de projets",
      photo: "/khane.webp",
    },
    {
      name: "Aminata Kane FALL",
      title: "Pôle Passation des marchés",
      photo: "/fall.jpg",
    },
    {
      name: "Oumou GAYE",
      title: "Responsable Courriers",
      photo: "/oumou-gaye.jpg",
    },
    {
      name: "Cheikhouna Amala GUEYE",
      title: "Agent de Courriers",
      photo: "/amala.webp",
    },
    {
      name: "Harouna SYLLA",
      title: "Informaticien",
      photo: "/sylla.webp",
    },
    {
      name: "Coumba Doudou DIATTA",
      title: "Assistante",
      photo: "/coumba.jpg",
    },
    {
      name: "Alassane NDIAYE",
      title: "Agent d'archive",
      photo: "/alassane.webp",
    },
    {
      name: "Modou DIOUF",
      title: "Chauffeur PMN",
      photo: "/modou.webp",
    },
    {
      name: "Alpha Omar Diallo",
      title: "Chauffeur PMN",
      photo: "/alpha.webp",
    },
  ];

  return (
    <>
      <SEO
        title="Personnel du PMN"
        description="Découvrez l'équipe du Projet Mobilier National, composée de professionnels dévoués à la promotion de l'artisanat sénégalais."
        keywords="PMN, équipe, personnel, coordinateur, administration, finance, ressources humaines"
        ogImage="/images/carrousel3.webp"
      />

      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
        {/* Hero Section */}
        <section className="relative py-24 bg-[#1E3D1A]">
          <div className="absolute inset-0 bg-[url('/images/carrousel3.webp')] opacity-50" />
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="max-w-3xl mx-auto text-center"
            >
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">
                Personnel du PMN
              </h1>
              <p className="text-xl text-white/90">
                Découvrez les membres de notre équipe dévouée au service de
                l'artisanat sénégalais
              </p>
            </motion.div>
          </div>
        </section>

        {/* Team Grid */}
        <section className="py-24">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
              {teamMembers.map((member, index) => (
                <motion.div
                  key={member.name}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  whileHover={{ scale: 1.02 }}
                  className="group relative overflow-hidden rounded-2xl shadow-lg bg-white"
                >
                  <div className="w-full h-[300px]">
                    <img
                      src={member.photo}
                      alt={member.name}
                      className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                    <div className="p-8 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                      <h3 className="text-lg font-semibold mb-2">
                        {member.name}
                      </h3>
                      <p className="text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        {member.title}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <Apply />
      </div>
    </>
  );
};

export default Team;
